import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ZipFieldProps } from './types';
import useRequiredComponent from './useRequiredComponent';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import FormInput from '@/form/FormInput';
import { NumericZipCountryCodes } from '@/schema';
function ZipField(t0) {
  const $ = _c(7);
  const {
    required
  } = t0;
  const FieldComponent = useRequiredComponent(required);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["country_alpha2"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [countryAlpha2] = useDonationFormValues(t1);
  const numericZip = !!NumericZipCountryCodes[countryAlpha2 as keyof typeof NumericZipCountryCodes];
  const t = useTranslations("nextjs.donate.attributes");
  let t2;
  if ($[1] !== t) {
    t2 = t("zip");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const label = t2;
  const t3 = numericZip ? "tel" : "text";
  let t4;
  if ($[3] !== FieldComponent || $[4] !== label || $[5] !== t3) {
    t4 = <FieldComponent name="zip" title={label} as={FormInput} inputMode={t3} />;
    $[3] = FieldComponent;
    $[4] = label;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
export default ZipField;